import { ApiCall } from '../ApiClient';
import { ResultData } from '../ApiTypes';

const get = <TResponse>(def: Omit<ApiCall<never, TResponse>, 'method'>): ApiCall<never, TResponse> =>
    Object.assign(def, { method: 'get' });

const post = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'post' });

export type SettingPatchData = Record<string, any>;

export const settingsEndpoints = {

    patch: (values: SettingPatchData) => post<ResultData>({
        path: '/settings.patch',
        body: values,
    }),

};
